import PropTypes from 'prop-types'
import React from 'react'

const Panel = ({ steps, currentStep }) => {
  const stepNumber = steps.indexOf(currentStep)

  const stepAlignClass = (panelIndex) => {
    switch (panelIndex) {
      case 0:
        return ' panel-left'
      case 1:
        return ' panel-center'
      case 2:
        return ' panel-right'
    }
  }

  const stepStateClass = (panelIndex) => {
    const isCurrentStep = stepNumber == panelIndex
    if (isCurrentStep) return ' active'
    return (stepNumber > panelIndex) ? ' completed' : ''
  }

  const panelSteps = () => {
    return steps.map((step, i) => {
      const alignClass = stepAlignClass(i)
      const stateClass = stepStateClass(i)

      return <div className={'panel-step' + alignClass} key={i}>
        <div className={'step-number' + stateClass}>
          {stepNumber > i ? <i className='fa fa-check'></i> : <span>{`0${i + 1}`}</span>}
        </div>
        <div className={'step-name' + stateClass}>{step}</div>
      </div>
    })
  }

  return <div className='new-team-form__panel'>
    {panelSteps()}
  </div>
}

Panel.propTypes = {
  steps: PropTypes.array.isRequired,
  currentStep: PropTypes.string.isRequired,
}

export default Panel
